import { css } from '@emotion/css';
import { Fonts, Spacing } from '@snapchat/snap-design-system';

export const connectedPixelColumnClassName = css({
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing['2XS'],
});

export const connectedPixelIdClassName = css({
  ...Fonts.Paragraph.P300,
  fontWeight: 500,
  margin: 0,
});
